import React, { useEffect } from 'react'

import { BonusModal, BonusModalProps } from '../../modals/BonusModal'
import { FeatureFlagsModal, FeatureFlagsModalProps } from '../../modals/FeatureFlagsModal'
import { LoginModal, LoginModalProps } from '../../modals/LoginModal'
import { OfferExpiredModal, OfferExpiredModalProps } from '../../modals/OfferExpiredModal'
import { ProductModal, ProductModalProps } from '../../modals/ProductModal'
import { UnavailableModal, UnavailableModalProps } from '../../modals/UnavailableModal'

export type OverlayProps = {
  overlay:
    | BonusModalProps
    | FeatureFlagsModalProps
    | LoginModalProps
    | OfferExpiredModalProps
    | ProductModalProps
    | UnavailableModalProps
    | null
}

export function Overlay({ overlay }: OverlayProps) {
  /* Hide body scroll when modal is open */
  useEffect(() => {
    if (overlay !== null) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [overlay])

  if (!overlay) {
    return null
  }

  switch (overlay.type) {
    case 'BONUS_INFO':
      return <BonusModal />
    case 'FEATURE_FLAGS':
      return <FeatureFlagsModal />
    case 'LOGIN':
      return <LoginModal {...overlay.props} />
    case 'OFFER_EXPIRED':
      return <OfferExpiredModal {...overlay.props} />
    case 'PRODUCT':
      return <ProductModal {...overlay.props} />
    case 'UNAVAILABLE':
      return <UnavailableModal />
    default:
      return null
  }
}
